import { render } from "./CategoryCard.vue?vue&type=template&id=665c0a91&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=665c0a91&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665c0a91"]])

export default __exports__